import React, { useCallback } from 'react';

import { Stack } from '@mui/material';

import { Chip, Icon } from '@sbv-clients/ui-shared';

import { PositionShiftTypeDisplay } from './positionShiftTypeDisplay';

export enum PageStatusType {
  DRAFTING = 'Drafting',
  VIEWING = 'Viewing',
}

function getChip(
  pageStatus: PageStatusType | undefined,
  draftId: number,
  handleDraftExit: () => void
) {
  switch (pageStatus) {
    case PageStatusType.DRAFTING:
      return (
        <Chip
          sx={{ fontWeight: 'bold' }}
          icon={
            <Icon name={'EditCalendar'} iconProps={{ fontSize: 'small' }} />
          }
          color={'warning'}
          variant={'filled'}
          label={`Drafting #${draftId}`}
          onDelete={handleDraftExit}
          // deleteIcon={<Icon name={'AssignmentReturn'} />}
        />
      );
    case PageStatusType.VIEWING:
      return (
        <Chip
          color={'secondary'}
          variant={'outlined'}
          label="Viewing Existing Schedule"
        />
      );
    default:
      return null;
  }
}

export function PageStatus({
  useContextFn,
}: {
  useContextFn: () => {
    pageStatus: PageStatusType | undefined;
    draftId: number;
    setDraftId: (draftId: number) => void;
    positionId: number;
    shiftTypeId: number;
    clearRememberedDraftById: (id: number) => void;
    setChangesMadeOnDraft: (value: boolean) => void;
  };
}) {
  const {
    pageStatus,
    draftId,
    setDraftId,
    shiftTypeId,
    positionId,
    clearRememberedDraftById,
    setChangesMadeOnDraft,
  } = useContextFn();
  const handleDraftExit = useCallback(() => {
    // clear any remembered drafts for this draft id when the user
    // explicitly exits draft mode
    if (draftId) {
      clearRememberedDraftById(draftId);
      setChangesMadeOnDraft(false);
    }
    setDraftId(0);
  }, [clearRememberedDraftById, draftId, setChangesMadeOnDraft, setDraftId]);
  return (
    <Stack direction={'row'} spacing={2} alignItems={'center'}>
      {positionId !== 0 && shiftTypeId !== 0 && (
        <PositionShiftTypeDisplay
          shiftTypeId={shiftTypeId}
          positionId={positionId}
        />
      )}
      {getChip(pageStatus, draftId, handleDraftExit)}
    </Stack>
  );
}
